import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { RegisterTaxpayerRequest } from 'src/app/models/account';

@Component({
  selector: 'app-register-taxpayer-form',
  templateUrl: './register-taxpayer-form.component.html',
  styleUrls: ['./register-taxpayer-form.component.css']
})
export class RegisterTaxpayerFormComponent implements OnInit {
  @Input()
  data: RegisterTaxpayerRequest;
  @Input()
  submitting: false;

  @Output() onNextStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPrevStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpenTNCDialog: EventEmitter<any> = new EventEmitter<any>();
  public stepName: string = "taxpayer-profile";
  public npwpNumberMask = [/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,'-',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/];

  constructor(private modalService: NgbModal, private toastr: ToastrService) { }

  ngOnInit() {
  }

  nextStep(isValid:boolean) {
    if(isValid){
      this.onNextStep.emit({
        step: this.stepName,
        data: this.data,
      });
    } else {
      this.toastr.error('Terdapat data yang belum lengkap, mohon periksa kembali.', '', {
        timeOut: 3000
      });
    }
  }

  prevStep() {
    this.onPrevStep.emit({
      step: this.stepName,
      data: this.data,
    });
  }

  onFileChanged(files: FileList): void {
    if (files.length > 0) {
      const file = files.item(0);
      this.data.file_name = file.name;
      this.data.file = file;
    }
  }

  onSKKPhanged(files: FileList): void {
    if (files.length > 0) {
      const file = files.item(0);
      this.data.sppkp_file_name = file.name;
      this.data.sppkp_file = file;
    }
  }

  onStatementFileChanged(files: FileList): void {
    if (files.length > 0) {
      const file = files.item(0);
      this.data.statement_file_name = file.name;
      this.data.statement_file = file;
    }
  }

  isFormValid() {
    let result = false;

    // check form data
    if (!this.data.has_npwp && this.data.statement_file_name && this.data.aggreement) {
      result = true;
    } else {
      if (this.data.npwp_number && this.data.name && this.data.address && this.data.file_name && this.data.aggreement) {
          if (!this.data.is_non_pkp && this.data.sppkp_file_name || this.data.is_non_pkp) {
            result = true;
          }
      }
    }

    return result;
  }

  openTNCDialog() {
    if (!this.data.aggreement) {
      this.onOpenTNCDialog.emit();
    }
  }

}
